<template>
  <div id="manage">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'manage'
}
</script>




// WEBPACK FOOTER //
// src/views/contract/manage/Manage.vue